import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { AllDeviceInfo, User } from '@interfaces';
import { AvailableLanguages } from '@constants';
import { UsersFacade } from '@state/users';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { DeviceInfoService } from '@core/services/device-info.service';

@Component({
  selector: 'app-user-settings-consents',
  templateUrl: './user-settings-consents.component.html',
  styleUrls: ['./user-settings-consents.component.scss'],
})
export class UserSettingsConsentsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new ReplaySubject(1);

  @Input() myself: User;
  @Input() currentLang: AvailableLanguages;

  public deviceInfo: AllDeviceInfo;

  public userConsents: Partial<User>;
  public tableConsents: Array<{
    label: string;
    urlHtml: string;
    acceptedAt: string;
  }>;

  constructor(
    private readonly usersFacade: UsersFacade,
    private readonly translateService: TranslateService,
    private readonly deviceInfoService: DeviceInfoService
  ) {}

  public ngOnInit(): void {
    this.deviceInfo = this.deviceInfoService.getInfo();

    this.usersFacade.getUserConsentsSuccess$.pipe(takeUntil(this.destroy$)).subscribe(({ userConsents }) => {
      this.userConsents = userConsents;
      this.buildTableConsents();
    });

    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.buildTableConsents();
    });

    this.usersFacade.getUserConsents();
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private buildTableConsents(): void {
    if (!this.userConsents) {
      return;
    }

    this.tableConsents = [
      {
        label: this.translateService.instant('USER_SETTINGS.CONSENTS.TOS'),
        urlHtml: this.translateService.instant('USER_SETTINGS.CONSENTS.LINKS.TOS'),
        acceptedAt: this.userConsents.GDPRAcceptedAt,
      },
      {
        label: this.translateService.instant('USER_SETTINGS.CONSENTS.GDPR'),
        urlHtml: this.translateService.instant('USER_SETTINGS.CONSENTS.LINKS.PRIVACY_POLICY'),
        acceptedAt: this.userConsents.GDPRAcceptedAt,
      },

      /**
       *  3rd one should be consent to the data processing, leaving it out for now.
       *  (11.2025) Data processing consent text for BRIDGE is :
       *     Wyrażam zgodę na przetwarzanie moich danych osobowych w zakresie niezbędnym do świadczenia usług
       *     przez Concierge Poland Sp. z o.o. z siedzibą przy ul. Kamiennej 21, 31-403 Kraków,
       *     wpisaną do rejestru przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd Rejonowy dla Krakowa–Śródmieścia w Krakowie,
       *     Wydział XI Gospodarczy KRS, z kapitałem zakładowym 120,000.00 złotych, NIP: 6762490678, REGON 362057399, KRS 0000566891.
       *
       *  */
    ];
  }
}
